import { svgPathStyles } from "@digits-shared/components/SVG/svgIconStyles"
import SearchBox from "@digits-shared/components/UI/Elements/SearchBox"
import zIndexes from "@digits-shared/DesignSystem/zIndexes"
import colors from "@digits-shared/themes/colors"
import fonts from "@digits-shared/themes/typography"
import styled from "styled-components"
import {
  SIDEBAR_MENU_SIDE_PADDING,
  SIDEBAR_WIDTH,
} from "src/frontend/components/Shared/NavSidebar/sidebarConstants"

export const PickerContainer = styled.div`
  padding: 12px ${SIDEBAR_MENU_SIDE_PADDING}px;
  width: fill-available;
`

export const EntitiesSearch = styled(SearchBox)`
  flex-shrink: 0;
  border-color: ${colors.secondary10};
  border-radius: 6px;
  width: calc(100% - 32px);
  margin: 4px auto 0;
  height: 40px;

  &:focus-within,
  &:hover {
    border-color: ${colors.secondary60};
  }

  svg {
    width: 16px;
    height: 16px;
    ${svgPathStyles(colors.secondary50, 1.5)};
  }

  input {
    color: ${colors.secondary};

    &::placeholder {
      text-transform: none;
      color: ${colors.secondary70};
    }
  }
`

export const BusinessName = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  &.pending {
    opacity: 50%;
  }
`

export const Pending = styled.div`
  font-size: 10px;
  font-weight: ${fonts.weight.heavy};
  color: ${colors.translucentPrimary80};
`

export const EmptyMessage = styled.div`
  color: ${colors.translucentSecondary50};
  height: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const EntityList = styled.div`
  flex: 1;
  overflow-y: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  scrollbar-gutter: stable;
  // ensure consistent visual padding with or without scrollbars
  padding: 4px calc(16px - var(--scrollbar-width, 0px)) 4px 16px;
  gap: 4px;
`

export const DropdownContents = styled.div`
  max-height: min(400px, calc(100vh - 220px));
  overflow-y: auto;
  // Setting "position: fixed" allows the menu to retain its position below the trigger
  // while permitting it to overflow the container as long as no explicit positioning is set
  // i.e. no top/left/bottom/right, but specifying the width is required
  position: fixed;
  width: calc(${SIDEBAR_WIDTH}px - ${2 * SIDEBAR_MENU_SIDE_PADDING}px);
  z-index: ${zIndexes.sidebarMenu + 1};
  margin-top: 4px;
  background: ${colors.white};
  border: 1px solid ${colors.translucentSecondary20};
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  ${fonts.scale.body};
`

export const CustomDropdown = styled.div`
  height: 40px;
  user-select: none;

  svg {
    width: 16px;
    ${svgPathStyles(colors.secondary, 2)};
  }
`

export const DropdownExpando = styled.div<{ disabled?: boolean }>`
  border-radius: 6px;
  border: 1px solid ${colors.translucentSecondary20};
  background: ${colors.white};
  position: relative;
  z-index: 2;

  &:not(.expanded):hover {
    border-color: ${colors.translucentSecondary30};
  }

  &.expanded {
    box-shadow: 0 0 10px 0 ${colors.translucentSecondary20};
  }

  &[disabled] {
    svg {
      display: none;
    }
  }
`

export const DropdownHead = styled.button`
  font-size: 14px;
  display: flex;
  background: unset;
  border: unset;
  width: 100%;
  align-items: center;
  gap: 8px;
  padding: 8px;
  cursor: pointer;

  [disabled] > & {
    pointer-events: none;
  }
`
